// This file is intended for global constants that are shared across
// the application. Use this file sparingly. For constants with a single
// usage, it can be better to include them in the module scope of the
// file they're used in.
export const TrackedInfo = {
	USER_SESSION_ID: 'session.id',
	CONTACT_ID: 'contact.id',
	SITE_ID: 'site.id',
	SITE_TYPE: 'site.type',
	ACCOUNT_ID: 'account.id',
	PORTAL_ID: 'portal.id',
	SEM_ID: 'RlocalUID',
	PERMANENT_COOKIE_ID: 'permanent.cookie.id',
	JAVASCRIPT_ENABLED: 'javascript.enabled',
	COLOR_DEPTH: 'color.depth',
	WIDTH: 'width',
	HEIGHT: 'height',
	PAGE_ID: 'pathname',
	SESSION_REFERRER: 'session.referrer',
	SESSION_REFERRER_DOMAIN: 'session.referrer.domain',
	REFERRER: 'referrer',
	TYPE: '0vt',
	EXTRA: '0ve',
	USER_AGENT: 'user.agent',
	REMOTE_HOST: 'remote.host',
	REMOTE_ADDRESS: 'remote.address',
	LOCALE: 'locale',
	REACHLOCAL_COOKIE: 'reachlocal.cookie',
	KEYWORD_ID: 'keyword.id',
	REGION_ID: 'region.id',
	RANDOM_VIDEO: 'random.video',
	TCD_KEYWORD_ID: 'tcd.kw.id',
	TCD_AD_ID: 'tcd.ad.id',
	TCD_CAMPAIGN_ID: 'tcd.cmp.id',
	PLATFORM: 'platform',
	VERSION: 'version',
	SKIN: 'skin',
	TEMPLATE_EXTRA: 'template.extra',
	USER_PROFILE_ID: 'user.profileId',
	UNIVERSAL_USER_ID: 'userId',
	FORM_EVENT_ID: 'formEventId',
	AD_SOURCE: 'adSource',
	CAMPAIGN_PARAMS: 'campaignparams',

	CLLC_BID: 'bid',
	CLLC_PID: 'pid',
	CLLC_ADID: 'adid',
	CLLC_RID: 'rid',
	CLLC_MKT_CODES: 'mktcodes',

	FMCCMP: 'fmccmp',
	ALT_SOURCE: 'AltLeadSource',
	SECONDARY_LEAD_SOURCE: 'SecondaryLeadSource',
	T3_WEBSITE: 't3website',

	CID: 'cid',
	PDSRCH: 'pdsrch',

	REF_ID: 'refId',

	DDC_REF: 'ddcref',
	GC_LID: 'gclid',

	CLICKPATH: 'cms.ClickPath',
	ADOBE_CLOUD_ID: 'adobeCloudId',

	UTM_CAMPAIGN: 'utm_campaign',
	UTM_MEDIUM: 'utm_medium',
	UTM_SOURCE: 'utm_source',
	ADS_ADGROUP: 'ads_adgroup',
	ADS_ADID: 'ads_adid',
	ADS_DIGADPROVIDER: 'ads_digadprovider',

	ADP_FOUREYES: 'adpFoureyes',

	MARKETING_CODE: 'mktgCode',
	ZIP: 'zip',

	VEHICLE_VIEW: 5,
	QF4_VIEW: 6,
	FORM_VIEW: 7,
	FORM_SUBMIT: 8,
	QF3_VIEW: 9,
	PAGE_VIEW: 10,
	EDMUNDS_CONFIGURATOR_VIEW: 12,
	EVENT_VIEW: 13,
	SPECIAL_VIEW: 14,
	GLOBAL_VEHICLE_VIEW: 15,
	VIDEO_VIEW: 16,
	INVENTORY_ITEM_VIEW: 17
};
